import React, { useState } from 'react';
import { ModalArea } from '../ModalButtonArea';
import TemplateInfoTable from '../../components/Automation/TemplateInfoTable';
import { Tab, Tabs } from 'react-bootstrap';
import styles from './_AutomationTemplateInfo.module.scss';
import cx from 'classnames';

function AutomationTemplateInfo({ automationData, title, isTemplateInformation, show, setShow }) {
  const [activeTab, setActiveTab] = useState('objects-details');

  let subtitle = '';

  let objectsData = {};
  let cameraData = {};

  if (isTemplateInformation) {
    subtitle = <span className="fs-6">Assigned from excel {automationData?.excel_name || "No Excel"}</span>;

    objectsData.tableHeadings = (
      <>
        <th>
          <div>Object Name</div>
        </th>
        <th>
          <div>Texture SKU/ Color</div>
        </th>
      </>
    );
    cameraData.tableHeadings = (
      <>
        <th>
          <div>Rendering Camera</div>
        </th>
        <th>
          <div>File Format</div>
        </th>
      </>
    );

    objectsData.tableBody = automationData?.aa_objects.map((item) => ({
      name: item.display_name,
      texture: item.texture ? item.texture.sku_id : item.color_code,
    }));

    cameraData.tableBody = automationData?.aa_camera_angles.map((item) => ({
      name: `${item.camera_name} (${item.size})`,
      format: automationData.file_format,
    }));
  } else {
    objectsData.tableHeadings = (
      <>
        <th>
          <div>Object Name</div>
        </th>
      </>
    );

    cameraData.tableHeadings = (
      <>
        <th>
          <div>Rendering Camera</div>
        </th>
        <th>
          <div>Resolution</div>
        </th>
      </>
    );

      objectsData.tableBody = automationData?.automation_objects.map((_item) => ({ name: _item.display_name }));
      cameraData.tableBody = automationData?.automation_camera_angles.map((_item) => ({
        name: _item.name,
        resolution: _item.size,
      }));
  }

  const handleSelect = (e) => {
    setActiveTab(e);
  };

  const onClose = () => {
    setShow(false);
    setActiveTab('objects-details');
  };

  return (
    <ModalArea
      showModal={show}
      setShowModal={onClose}
      className="check"
      title={title}
      subtitle={subtitle}
      size="lg"
      modalClassName="automation-template-info"
      centered={true}
      body={
        <div className="mySettings automationInfoTable">
          <div className="setting-tabs ">
            <Tabs
              className={cx('mySettings-top-tabs px-0', styles.fullWidthButton)}
              mountOnEnter
              activeKey={activeTab}
              onSelect={handleSelect}>
              <Tab eventKey="objects-details" title="Objects Details" className="tableScrollY">
                <TemplateInfoTable
                  responsive="md"
                  tableHeadings={objectsData.tableHeadings}
                  tableBody={objectsData.tableBody}
                  isPagination={false}
                />
              </Tab>
              <Tab eventKey="camera-details" title="Camera Details" className="tableScrollY">
                <TemplateInfoTable
                  responsive="md"
                  tableHeadings={cameraData.tableHeadings}
                  tableBody={cameraData.tableBody}
                  isPagination={false}
                />
              </Tab>
            </Tabs>
          </div>
          {automationData?.dpi && <h6 style={{
            margin: 0,
            padding: '1rem 0.5rem 0'
          }}>DPI: {automationData?.dpi}</h6>}
        </div>
      }
    />
  );
}

export default AutomationTemplateInfo;
